/**
 * 基于 MagicBox 中 tdoc-offline-api 模块
 * 提供文档新建(包含异常处理)等公共方法
 */
import { getUid } from '@tencent/docs-login';
import ua from '@tencent/docs-user-agent';
import { DOCUMENT_TYPE } from '@tencent/ark-model';
import type { IOfflineApi, IOfflineConfig } from '@tencent/tdoc-offline-api';
import { getXSRF } from '@src/slide/domain/slide-app/utils/cookie-utils';
import { DVER } from '../constants';

export default class OfflineApiManager {
    private static offlineApiInstance: IOfflineApi;

    public static async offlineApi(): Promise<IOfflineApi> {
        if (!OfflineApiManager.offlineApiInstance) {
            const OFFLINE_CONFIG: IOfflineConfig = {
                user: { uid: getUid() || '' },
                requestParams: {
                    xsrf: getXSRF(),
                },
                getDataVersion: () => DVER,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                monitorReporter: { report: () => {} },
                useNativeDB: ua.isSupportNativeDatabase,
            };
            const { DocumentAdapterFactory, OfflineApi } = await import('@tencent/tdoc-offline-api');
            const adapter = await DocumentAdapterFactory.createAdapter(DOCUMENT_TYPE.slide);
            OfflineApiManager.offlineApiInstance = new OfflineApi(adapter, OFFLINE_CONFIG);
        }
        return OfflineApiManager.offlineApiInstance;
    }
}
